// extracted by mini-css-extract-plugin
export default {"container":"pM-z","topReviewHeading":"qM-z","criticalReview":"rM-z","favorableReview":"sM-z","vsSeparator":"tM-z"};